module.exports = __webpack_public_path__ + "img/webank-app-code.10161742.5161be54.png";